import type { ValidationRule, ValidationType } from "../../../../../components/Form/types/types";
import { TagsContainer, TagStyle } from "../../../../../components/Tag/TagStyle";

interface ValidationTagsProps {
    tags: ValidationRule[];
    onChange?: (inputValue: ValidationRule[]) => void;
    showClose?: boolean;
}

export const ValidationTags = ({ tags, onChange, showClose }: ValidationTagsProps) => {
    const removeObjectWithName = (arr: ValidationRule[], fieldName: ValidationType) => {
        return arr.filter((obj) => obj.name !== fieldName);
    };

    const onRemoveTag = (tagToRemove: ValidationRule) => {
        if (tags && onChange) {
            const newTags = removeObjectWithName(tags, tagToRemove.name);
            onChange(newTags);
        }
    };

    return (
        <TagsContainer>
            {tags.map((tag) => {
                return (
                    <TagStyle key={tag.name} closable={showClose} onClose={() => onRemoveTag(tag)}>
                        {tag.params ? `${tag.name} ${tag.params}` : tag.name}
                    </TagStyle>
                );
            })}
        </TagsContainer>
    );
};
